import { __assign, __rest } from "tslib";
import React from 'react';
export var Tab = function (_a) {
    var children = _a.children, title = _a.title, // Title and tabKey are only added here to prevent warnings from them being added to the div. These are unused
    tabKey = _a.tabKey, // ^
    icon = _a.icon, rest = __rest(_a, ["children", "title", "tabKey", "icon"]);
    return React.createElement("div", __assign({}, rest), children);
};
